import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./next-steps.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./next-steps.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { AlertType } from "../../models/alert";
import { AppControllerService } from "../../../app-controller.service";
import { ViewApplicationRoutingConstants } from "../../../application/view-application/view-application-routing.constants";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../constants/shared.constants";
import { ViewApplicationStepManagementConstants } from "../../../application/view-application/view-application-step-management/view-application-step-management.constants";
import { SelectedApplicationService } from "../../services/selected-application/selected-application.service";
import { take, takeUntil } from "rxjs/operators";
import { NextStepsConstants } from "./next-steps.constants";
import { CreateApplicationRoutingConstants } from "../../../application/create-application/create-application-routing.constants";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { Subject } from "rxjs";
import { ViewApplicationService } from "../../../application/view-application/view-application.service";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let NextStepsComponent = class NextStepsComponent {
    appController;
    currentStepService;
    selectedApplicationService;
    viewApplicationService;
    changeDetectorRefs;
    router;
    route;
    _destroy$ = new Subject();
    nextStepsFormControlName = NextStepsConstants.NEXT_STEPS_FORM_CONTROL_NAME;
    continueStepText = SharedConstants.CONTINUE_STEP_TEXT;
    saveStepText = SharedConstants.SAVE_STEP_TEXT;
    viewApplicationText = SharedConstants.VIEW_APPLICATION_TEXT;
    dropdownPlaceholderMessage = SharedConstants.NO_OPTION_SELECTED;
    nextStepsLabel = SharedConstants.NEXT_STEPS_LABEL_TEXT;
    stepForm;
    nextSteps;
    currentStep;
    showDisabled = true;
    showContinueButton = true;
    continueDisabled = true;
    isEnd = false;
    application;
    selectedApplicationSubscription;
    jobCurrentStepsSubscription;
    showStepSaveSubscription;
    showStepContinueSubscription;
    triggerContinueSubscription;
    constructor(appController, currentStepService, selectedApplicationService, viewApplicationService, changeDetectorRefs, router, route) {
        this.appController = appController;
        this.currentStepService = currentStepService;
        this.selectedApplicationService = selectedApplicationService;
        this.viewApplicationService = viewApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.router = router;
        this.route = route;
    }
    ngOnInit() {
        this.initialiseForm();
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((app) => {
            this.application = app;
        });
        this.showStepSaveSubscription = this.currentStepService.$showStepSave.subscribe((show) => {
            this.showDisabled = show;
            this.changeDetectorRefs.detectChanges();
        });
        this.showStepContinueSubscription = this.currentStepService.$showStepContinue.subscribe((show) => {
            this.showContinueButton = show;
            this.continueDisabled = show;
            this.changeDetectorRefs.detectChanges();
        });
        this.triggerContinueSubscription = this.currentStepService.$triggerContinue.subscribe((trigger) => {
            if (trigger === true) {
                this.triggerNextSteps();
                this.changeDetectorRefs.detectChanges();
            }
        });
        const currentStep = this.currentStepService.currentStep;
        if (currentStep !== null) {
            this.nextSteps = currentStep.destinationSteps;
            this.nextSteps.forEach(item => {
                item.displayName = item.name;
            });
            if (currentStep.parsedStepMeta?.options && this.nextSteps !== undefined && this.nextSteps !== null && this.nextSteps.length > 0) {
                // tslint:disable-next-line:forin
                for (const id in currentStep.parsedStepMeta?.options) {
                    const option = currentStep.parsedStepMeta?.options[id];
                    let found = false;
                    for (const stepIndex in this.nextSteps) {
                        if (this.nextSteps[stepIndex].name.trim() === option.optionStepName.trim()) {
                            found = true;
                            this.nextSteps[stepIndex].displayName = option.optionLabel;
                            break;
                        }
                    }
                    if (!found) {
                        this.appController.showMessage(NextStepsConstants.INVALID_METADATA, AlertType.Error);
                    }
                }
            }
            if (currentStep.type === "MndRiskAwait" && currentStep.parsedStepMeta.approvalStepName !== null && currentStep.parsedStepMeta.approvalStepName !== "") {
                const approvalStepName = currentStep.parsedStepMeta.approvalStepName;
                this.nextSteps = this.nextSteps.filter(s => s.name !== approvalStepName);
            }
            this.nextSteps.sort(function (a, b) {
                const textA = a.displayName.toUpperCase();
                const textB = b.displayName.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            if (this.nextSteps.length === 1) {
                this.stepForm.get(this.nextStepsFormControlName).setValue(this.nextSteps[0], {
                    onlySelf: true,
                    emitEvent: true
                });
                this.nextSteps[0].displayName = "Continue";
            }
            this.changeDetectorRefs.detectChanges();
            if (currentStep !== undefined && currentStep !== null && currentStep.type.toLowerCase() === "end") {
                this.isEnd = true;
            }
            else {
                this.isEnd = false;
            }
            this.currentStep = currentStep;
            this.changeDetectorRefs.detectChanges();
            this.currentStepService.setLoadStep(true);
        }
    }
    saveStep($event) {
        this.currentStepService.currentStepComponent.save(false);
    }
    triggerNextSteps() {
        if (this.nextSteps.length > 1) {
            this.appController.showMessage(SharedConstants.TOO_MANY_NEXT_STEPS, AlertType.Warning);
            return;
        }
        this.continueStep(this.nextSteps[0]);
    }
    continueStep(step) {
        this.stepForm.get(this.nextStepsFormControlName).setValue(step, {
            onlySelf: true,
            emitEvent: true
        });
        this.stepForm.get(this.nextStepsFormControlName).updateValueAndValidity();
        this.stepForm.updateValueAndValidity();
        if (!this.stepForm.valid) {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
            return;
        }
        const nextStep = this.stepForm.get(this.nextStepsFormControlName).value;
        this.currentStepService.currentStepComponent.startContinue(this.currentStep.id, nextStep.id, nextStep.displayName)
            .pipe(takeUntil(this._destroy$), take(2))
            .subscribe((continueResult) => {
            if (continueResult !== null && continueResult === true) {
                this.viewApplicationService.updateTracker();
                this.nextSteps = [];
                this.changeDetectorRefs.detectChanges();
                this.appController.showMessage(ViewApplicationStepManagementConstants.SUCCESS_MESSAGE, AlertType.Success);
                this.jobCurrentStepsSubscription = this.currentStepService.getCurrentSteps(this.application.jobId, this.application.moduleId, true).subscribe({
                    next: data => {
                        this.stepForm.reset();
                    }, error: error => {
                        this.stepForm.reset();
                    }
                });
            }
        });
    }
    navigateToApplicationDetails($event) {
        this.currentStepService.setLoadStep(false);
        this.router.navigate([ViewApplicationRoutingConstants.APPLICATION_CONTENT_ROUTE, { loadSteps: false }], { relativeTo: this.route.parent?.parent });
    }
    shouldShowViewApplicationLink() {
        return !this.router.url.includes(AppRoutingConstants.createRouteToView(CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE));
    }
    initialiseForm() {
        this.stepForm = new FormGroup({
            nextSteps: new FormControl(null, [Validators.required])
        });
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: CurrentStepService },
        { type: SelectedApplicationService },
        { type: ViewApplicationService },
        { type: ChangeDetectorRef },
        { type: Router },
        { type: ActivatedRoute }
    ];
};
NextStepsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-next-steps",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], NextStepsComponent);
export { NextStepsComponent };
